<template>
    <div>
        <video ref="videoPlayer" class="video-js vjs-show-big-play-button-on-pause"></video>
    </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css'

export default {
    name: "VideoPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            player: null
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
                // console.log('onPlayerReady', this);
            })
        },
        dispose() {
            if (this.player) {
                this.player.dispose()
            }
        },
    },
    beforeDestroy() {
        this.dispose()
    },
}
</script>

<style scoped>

.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3,
video.video-js,
video.vjs-tech {
    max-height: 50vh;
    position: relative !important;
    width: 100%;
    height: auto !important;
    max-width: 100% !important;
    padding-top: 0 !important;
    line-height: 0;
    border-radius: 8px;
}

::v-deep .video-js .vjs-control-bar {
    border-radius: 0 0 8px 8px;
    margin-bottom: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
}

::v-deep .vjs-progress-holder {
    position: absolute;
    left: 0;
    margin: 0;
    height: 15px;
    width: 100%;
}

::v-deep .vjs-play-progress {
    background: #99CC00;
}

::v-deep .vjs-play-progress:before {
    display: none;
}

::v-deep .vjs-poster {
    border-radius: 8px;
}

::v-deep .video-js .vjs-big-play-button {
    height: 75px;
    width: 75px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: none;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

::v-deep .video-js .vjs-big-play-button:hover {
    background: rgba(255, 255, 255, 0.35);
}

::v-deep .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    content: "";
    background-image: url('~@/assets/img/play_white.png');
    background-size: contain;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

::v-deep .vjs-slider-horizontal .vjs-volume-level:before {
    display: none;
}

</style>